import GlobalState, {} from "../../../stores/GlobalState";
import Select, { components } from 'components/common/AppSelect'
import { observer } from 'mobx-react'

const DeployFirstPage = observer(({
        langv,
        deployprew,
        limit,
        formatDate,
        changesegmentationpage7
    }) =>{
        return (
        <>
           <div className='table_check'>
                <div className='table_check_head'> 
                    <div className='table_check_head_col2 b2 borahead'>
                    {langv?.segmentation?.attributes}
                    </div>
                    <div className='table_check_head_col1 b1 borahead'>
                    {langv?.segmentation?.dataset}
                    </div>
                    <div className='table_check_head_col3 b3 borahead'>
                    {langv?.segmentation?.source}
                    </div>
                    <div className='table_check_head_col4 b4 borahead'>
                    {langv?.segmentation?.last_changes}
                    </div>
                    <div className='table_check_head_col5 b5 borahead'>
                    {langv?.segmentation?.rows}
                    </div>
                </div>
                <div className='table_check_body'>
                    
                    {
                        deployprew.map((n, id)=>
                            <div className='table_check_body_line'>
                                
                                <div className='table_check_head_col2 b2 bora'>
                                    {n.attribute}
                                </div>
                                <div className='table_check_head_col1 b1 bora'>
                                    {n.dataset}
                                </div>
                                <div className='table_check_head_col3 b3 bora'>
                                    {n.source}
                                </div>
                                <div className='table_check_head_col4 b4 bora'>
                                    {formatDate(n.last_changes)}
                                </div>
                                <div className='table_check_head_col5 b5 bora'>
                                    {n.rows}
                                </div>
                            </div>
                        )
                    }
                    
                </div>
                <div className='table_check_body_button line_pagin_export'>
                    <div className='pagination_line'>
                        <div className='countpagepagination'>
                            {langv?.dataset?.main?.text9}  {(GlobalState.numpagesdatasetsportraits*1-1)*limit+1} -&nbsp;
                            
                            {
                                GlobalState.numpagesdatasetsportraits*limit<deployprew?.length?
                                GlobalState.numpagesdatasetsportraits*limit
                                :
                                deployprew?.length
                            }
                            &nbsp;of {deployprew?.length} {langv?.dataset?.main?.text10} 
                        </div>
                    
                        <div className='pagination pagdatasets'>
                            {
                                GlobalState.numpagesdatasetsportraits<2?
                                <div className='arrowP cursorenone' >

                                    <svg className='cursorenone' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g opacity="0.1">
                                        <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                                        <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                        <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                        <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="#020203"/>
                                        <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                                        <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                                        </g>
                                    </svg>

                                    


                                </div>
                                :
                                <div className='arrowP' onClick={()=>minusnumpagesmodelsportraits0()}>
                                    <svg className='def_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g opacity="0.4">
                                        <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                                        <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                        <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                        <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="#020203"/>
                                        <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                                        <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                                        </g>
                                    </svg>

                                    <svg className='hov_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="url(#paint0_linear_3491_117361)"/>
                                        <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="#020203"/>
                                        <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                                        <path d="M24.6377 8L19.7692 13M19.7692 13L24.6377 18M19.7692 13H34" stroke="black" stroke-opacity="0.2"/>
                                        <defs>
                                        <linearGradient id="paint0_linear_3491_117361" x1="1" y1="13" x2="45" y2="13" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#F5C538"/>
                                        <stop offset="1" stop-color="#F5C538" stop-opacity="0"/>
                                        </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                            }
                            
                            <div className='pagenum'>

                                {
                                    GlobalState.activeportraits?.total<limit?
                                    <span>01</span>: 
                                    GlobalState.numpagesdatasetsportraits<limit?
                                    <span>{"0"+GlobalState.numpagesdatasetsportraits}</span>
                                    :GlobalState.numpagesdatasetsportraits
                                }
                                / 
                                {
                                    deployprew?.length<limit?
                                    "01":
                                    Math.ceil(deployprew?.length/limit)<limit?
                                    "0"+Math.ceil(deployprew?.length/limit):
                                    Math.ceil(deployprew?.length/limit)
                                }
                            </div>
                            
                                {
                                    deployprew?.length?.total<limit?
                                    <div className='arrowP cursorenone'>
                                        <svg className='cursorenone' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g opacity="0.1">
                                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                            <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203"/>
                                            <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                            <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                            </g>
                                        </svg>
                                    </div>
                                    :
                                    GlobalState.numpagesdatasetsportraits==Math.ceil(deployprew?.length/limit)?
                                    <div className='arrowP cursorenone'>
                                        <svg className='cursorenone' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g opacity="0.1">
                                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                            <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203"/>
                                            <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                            <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                            </g>
                                        </svg>
                                    </div>
                                    :
                                    <div className='arrowP' onClick={()=>plusnumpagesmodelsportraits0()}>
                                        <svg className='def_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g opacity="0.4">
                                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="#020203"/>
                                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="black" stroke-opacity="0.2"/>
                                            <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203"/>
                                            <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                            <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                            </g>
                                        </svg>
                                        <svg className='hov_arrow' width="54" height="25" viewBox="0 0 54 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.5" y="2.5" width="53" height="21" rx="4.5" stroke="url(#paint0_linear_3491_117355)"/>
                                            <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="#020203"/>
                                            <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                            <path d="M29.3623 8L34.2308 13M34.2308 13L29.3623 18M34.2308 13H20" stroke="black" stroke-opacity="0.2"/>
                                            <defs>
                                            <linearGradient id="paint0_linear_3491_117355" x1="53" y1="13" x2="10" y2="13" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#F5C538"/>
                                            <stop offset="1" stop-color="#F5C538" stop-opacity="0"/>
                                            </linearGradient>
                                            </defs>
                                        </svg>
                                    </div>

                                }
                                
                            
                        </div>
                    </div>
                    <div className='table_check_body_button_but' onClick={()=>changesegmentationpage7(7)}>
                    {langv?.segmentation?.to_next_step}
                    </div>
                </div>
            </div>
            
        </>
        )
    }
)

export default DeployFirstPage;